import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import { QuestionWrapper } from 'common/components';
import { ClientForm } from 'common/forms';

import { QuestionTitle, PageControls } from '../../../../components';
import ClientIdentityDocumentUpload from '../../../../components/ClientIdentityDocumentUpload';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectInformationsCustomerInfo1,
  selectIsCustomerInfo2Visible,
  setInformationsClient1InfoValuesAction,
} from '../../../../ducks';
import { ClientFormValues } from '../../../../../../common/models/Forms';
import { FormikProps } from 'formik';
import { useFormStepContinueRef } from '../../../../hooks/useFormStepContinueRef';
import { FeatureProps } from '../../../../index';

export default function CustomerInfo1Feature({ isPrivileged }: FeatureProps) {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const initialValues = useSelector(selectInformationsCustomerInfo1);
  const isCustomerInfo2Visible = useSelector(selectIsCustomerInfo2Visible);
  const { bindFormik, continueWithSoftValidation, showSoftContinueHint } = useFormStepContinueRef<ClientFormValues>();

  function handleBackClick() {
    navigate(-1);
  }

  async function handleContinueClick() {
    await continueWithSoftValidation((values) => {
      handleSubmit(values);
    });
  }

  function bindSubmit(formik: FormikProps<ClientFormValues>) {
    bindFormik(formik);
  }

  function handleSubmit(values: ClientFormValues) {
    if (!isPrivileged) {
      dispatch(setInformationsClient1InfoValuesAction(values));
    }
    if (isCustomerInfo2Visible) {
      navigate(`/form/${id}/informations/customer-info-2`);
    } else {
      navigate(`/form/${id}/investing/experience`);
    }
  }

  return (
    <>
      <QuestionTitle>{t('informationsFeature.clientOne')}</QuestionTitle>
      {id ? <ClientIdentityDocumentUpload transactionId={id} clientIndex={1} disabled={isPrivileged} /> : null}
      <QuestionWrapper>
        <ClientForm bindSubmit={bindSubmit} initialValues={initialValues || undefined} onSubmit={handleSubmit} />
      </QuestionWrapper>
      <PageControls softContinueHint={showSoftContinueHint} onBack={handleBackClick} onContinue={handleContinueClick} />
    </>
  );
}
